var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmblem1FcKln(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 53.6,
    height: 53.596,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 26.8C0 11.999 12.003 0 26.791 0 41.596 0 53.6 12 53.6 26.8c0 14.802-12.003 26.796-26.809 26.796C12.003 53.596 0 41.602 0 26.8",
    style: {
      fill: "#e20613"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.245 26.8c0-13.015 10.56-23.566 23.577-23.566 13.01 0 23.569 10.551 23.569 23.566 0 13.013-10.56 23.558-23.569 23.558-13.017 0-23.577-10.545-23.577-23.558",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.994 26.798c0-12.054 9.776-21.827 21.828-21.827 12.046 0 21.821 9.773 21.821 21.827 0 12.055-9.775 21.823-21.821 21.823-12.052 0-21.828-9.768-21.828-21.823",
    style: {
      fill: "#e20613"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.123 13.527-.053.236-1.51-2.25-.636 7.86h-.203l-.619-7.86-1.514 2.25L21.815.991c-.188.86-2.775 12.772-2.775 12.772s-1.251-1.861-1.514-2.25l-2.66 33.409-.001.04a21.626 21.626 0 0 0 11.946 3.581h.031c4.272 0 8.403-1.239 11.948-3.583v-.045s-2.391-30.124-2.65-33.402l-1.514 2.25L31.845.99l-2.722 12.537",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.893 44.916-2.676-33.705-1.541 2.294L31.844.506l-2.822 12.999-1.54-2.294-.66 8.154-.641-8.154-1.542 2.294L21.814.506l-2.825 12.999-1.542-2.294-2.685 33.705v.104a21.75 21.75 0 0 0 12.049 3.625h.031c4.461 0 8.606-1.337 12.051-3.625z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.768 70.224 2.627 12.117 43.269-12.159-3.44-11.899z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-1.069 -44.578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.115 72.232-1.671.58.311-3.294 5.567-1.73-.981 10.482-3.89 1.085z",
    style: {
      fill: "#e20613"
    },
    transform: "translate(-1.069 -44.578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.066 30.544c-.1 1.087-1.252 2.012-2.291 2.329-1.059.274-2.079-.028-1.977-1.125.104-1.139 1.257-2.097 2.303-2.369 1.038-.298 2.065.041 1.965 1.165",
    style: {
      fill: "#e20613"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.699 65.717 7.214-2.043-.267 3.025-3.288.9-.094 1.103 2.884-.801-.264 2.699-2.876.816-.35 3.667-3.952 1.113z",
    style: {
      fill: "#e20613"
    },
    transform: "translate(-1.069 -44.578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.137 20.645c-.576-.387-1.324-.641-2.213-.396-1.176.332-2.223 1.494-2.334 2.639-.105 1.143.83 1.751 2 1.42.904-.249 1.654-.822 2.34-1.604l-.486 3.952c-.651.469-2.123 1-2.823 1.197-3.082.862-5.271-.78-4.99-3.758.283-3.059 2.998-6.199 6.168-7.097.881-.249 1.777-.359 2.588-.293z",
    style: {
      fill: "#e20613"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.139 34.594c-.04.417-.335.82-.657.941-.308.074-.529-.205-.498-.626.02-.427.313-.829.631-.894.324-.127.559.162.524.579m1.675-.484c-.029.425-.32.829-.642.938-.322.104-.534-.189-.504-.594.042-.42.312-.823.637-.923.316-.108.552.166.509.579m1.104 4.412c-.184 2.219-1.594 3.932-3.198 4.369-1.603.452-2.796-.54-2.607-2.756.179-2.166 1.602-3.935 3.202-4.385 1.586-.449 2.777.609 2.603 2.772m-3.892 1.115c-.069.801.3 1.221.867 1.076.574-.162 1.029-.824 1.098-1.596.06-.759-.267-1.266-.867-1.088-.596.167-1.03.89-1.098 1.608",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.866 85.393-3.502.954.578-6.904 1.903-.513-.389 4.681 1.594-.445z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-1.069 -44.578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.869 33.748 1.832-.486 1.391 3.355h.043c-.018-.578-.055-1.143-.008-1.742l.183-2.066 1.819-.503-.576 6.897-1.825.502-1.365-3.154-.074.014c.023.465.043.888 0 1.359l-.186 2.252-1.804.49zM16.467 38.044l1.848-.516-.303 3.014.044-.013c.075-.295.208-.576.335-.861l1.101-2.472 2.079-.573-1.922 3.813 1.525 3.054-2.205.617-.744-1.854c-.088-.227-.229-.438-.234-.703l-.052.013-.206 2.889-1.848.502z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmblem1FcKln);
export default __webpack_public_path__ + "static/media/Emblem_1.FC_Köln.1f73fa1274efdda671c8d671ab8c4f6a.svg";
export { ForwardRef as ReactComponent };